module.exports = __webpack_public_path__ + "img/padlock-unlock.b603766c.svg";